<template>
  <div>
    <GChart
      type="LineChart"
      :data="chartData"
      :options="chartOptions"
      @ready="generateData"
    />
  </div>
</template>
<script>
export default {
  props: ['intervals', 'threadData'],
  watch: {
    threadData: {
      deep: true,
      handler () {
        if (this.chart) {
          this.generateData(this.chart, this.google);
        }
      }
    }
  },
  data: function () {
    return {
      chart: null,
      google: null,
      chartData: [],
      chartOptions: {
        chartArea: {
          height: '100%',
          width: '100%',
          top: 20,
          left: 48,
          right: 16,
          bottom: 48
        },
        hAxis: {
          format: 'HH:mm',
          // showTextEvery: 1,
          gridlines: {minSpacing: 3}
        },
        height: '500',
        width: '100%',
        // curveType: 'function',
        series: [{'color': '#68b3c8'}],
        intervals: {'style': 'area'},
        legend: 'none',
        lineWidth: 4,
      },
    }
  },
  methods: {
    generateData: function (chart, google) {
      this.chart = chart;
      this.google = google;
      var data = new google.visualization.DataTable();
      var formatter = new google.visualization.DateFormat({pattern: 'dd. MM. YYYY HH:mm'});

      data.addColumn('datetime', 'x');
      data.addColumn('number', 'Channels Processed');
      data.addColumn({id: 'i0', type: 'number', role: 'interval'});
      data.addColumn({id: 'i1', type: 'number', role: 'interval'});

      if (Array.isArray(this.intervals)) {
        this.intervals.forEach((item) => {
          let threadData = this.threadDataByTime(item.reported_at);
          data.addRow([
            new Date(item.reported_at),
            Math.max(0, threadData),
            Math.max(0, item.grab.min),
            Math.max(0, item.grab.max)
          ]);
        });
      }
      formatter.format(data, 0);
      this.chartData = data;
    },
    threadDataByTime: function (time) {
      const thread = this.threadData;
      if (thread) {
        const item = thread.find(item => item.reported_at === time);
        if (item && item.data) {
          return item.data.grabCount;
        }
      }
      return 0;
    },
    redrawChart: function () {
      this.chart.draw(this.chartData, this.chartOptions)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GrabProcess/View/ServerStats/ThreadGrabChart.vue